// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3pgk0","choiceBoxes":"toolbarselects_choiceBoxes__19CV8","simpleField":"toolbarselects_simpleField__3dY7y"};